import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { ByLetterIcon, ByNumberIcon, ArrowUpTailIcon, ArrowDownTailIcon } from '@deliveryhero/armor-icons';
import { useComponentTheme } from '../../../utils/hooks';
import { useTableHeadCellClassNames } from './utils/useTableHeadCellClassNames';
import { TableHeadCellRoot } from './style';
import { tableHeadCellDefaultTheme } from './theme';
import { useTableHeadCell } from './utils/useTableHeadCell';
import { TABLE_HEAD_CELL_CLASS_PREFIX, TABLE_HEAD_CELL_SORTING_TYPE_NUMERICAL, TABLE_HEAD_CELL_SORTING_TYPE_ALPHABETICAL } from './constants';
import { TableCellLabel } from '../TableCellLabel';
export var TableHeadCell = forwardRef(function TableHeadCell(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useComponentTheme(TABLE_HEAD_CELL_CLASS_PREFIX, tableHeadCellDefaultTheme);
  var classNameComponents = useTableHeadCellClassNames(TABLE_HEAD_CELL_CLASS_PREFIX, className);

  var _useTableHeadCell = useTableHeadCell(props, ref),
      rootProps = _useTableHeadCell.rootProps,
      isAscending = _useTableHeadCell.isAscending,
      isDescending = _useTableHeadCell.isDescending,
      isIconAlphabetical = _useTableHeadCell.isIconAlphabetical,
      isIconNumerical = _useTableHeadCell.isIconNumerical;

  return React.createElement(TableHeadCellRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(TableCellLabel, null, children, isIconAlphabetical && React.createElement(ByLetterIcon, {
    marginLeft: 2,
    className: classNameComponents.AlphabeticalIcon
  }), isIconNumerical && React.createElement(ByNumberIcon, {
    marginLeft: 2,
    className: classNameComponents.NumericalIcon
  }), isAscending && React.createElement(ArrowUpTailIcon, {
    marginLeft: 2,
    className: classNameComponents.ArrowUpIcon
  }), isDescending && React.createElement(ArrowDownTailIcon, {
    marginLeft: 2,
    className: classNameComponents.ArrowDownIcon
  })));
});
TableHeadCell.defaultProps = {
  sortable: false
};